import type { OrganizationDefinition } from "../../domain/types/index.js";

type Props = {
  organizations: OrganizationDefinition[];
};

export function OrgPoolList({ organizations }: Props) {
  return (
    <>
      <h3>組織基盤プール</h3>
      <p>未取得から最大2つ提示されます。</p>
      <ul className="map-sheet-org-list" aria-label="組織基盤プール">
        {organizations.map((org) => (
          <li key={org.id} className="is-open">
            <strong>{org.name}</strong>
            <small>{org.text}</small>
          </li>
        ))}
      </ul>
    </>
  );
}
